'use es6';

import InitialMessage from 'conversations-visitor-message-history/initial-message/InitialMessage';
import { connect } from 'react-redux';
import { isStarted } from '../../../threads/operators/isStarted';
import { getChatHeadingConfig } from '../../../chat-heading-config/selectors/getChatHeadingConfig';
import { getSendFromResponders } from '../../../responders/selectors/getSendFromResponders';
import { publishVisitorMessage } from '../../../pubsub/actions/publishVisitorMessage';
import { hasUnansweredQuickReplyMessage } from '../../../selectors/chatSelectors';
import { getSelectedThread } from '../../../selected-thread/selectors/getSelectedThread';
import { getIsMobile } from '../../../selectors/getIsMobile';
import { getFilteredMessages } from '../../selectors/getFilteredMessages';
import { getIsUngatedForSpeechPoc } from '../../../widget-data/selectors/widgetDataSelectors';
import { getColoring } from '../../../selectors/widgetDataSelectors/getColoring';
const mapStateToProps = state => {
  var _state$speechPoc, _state$speechPoc2;
  const selectedThread = getSelectedThread(state);
  const coloring = getColoring(state);
  return {
    chatHeadingConfig: getChatHeadingConfig(state),
    sendFromResponders: getSendFromResponders(state),
    hasUnansweredQuickReplyMessage: hasUnansweredQuickReplyMessage(state, {
      thread: selectedThread
    }),
    isThreadStarted: isStarted(selectedThread),
    mobile: getIsMobile(state),
    messagesList: getFilteredMessages(state),
    speechPocActive: getIsUngatedForSpeechPoc(state) && ((_state$speechPoc = state.speechPoc) === null || _state$speechPoc === void 0 ? void 0 : _state$speechPoc.speechPocActive),
    audioPlaybackStatus: (_state$speechPoc2 = state.speechPoc) === null || _state$speechPoc2 === void 0 ? void 0 : _state$speechPoc2.audioPlaybackStatus,
    accentColor: coloring.accentColor
  };
};
const mapDispatchToProps = {
  publishMessage: publishVisitorMessage
};
export default connect(mapStateToProps, mapDispatchToProps)(InitialMessage);